// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".48d1be9f2c9427928eb7c058d89fafdcf02c455c.chunk.js";
};